import React, { Component } from 'react';
import userImage from '../../assets/images/user.png';

import Spinner from '../../components/UI/Spinner';

import { baseUrl } from '../../constants/backendUrls';
import { fetchProfilePicture, saveProfilePicture } from '../../utils/sideEffects';

class ProfilePicture extends Component {

    state = {
        isLoading: false,
        error: null,
        formModified: false,
        selectedFile: null,
        previewSrc: userImage
    }

    loadProfilePicture = async () => {
        this.setState({ isLoading: true });
        const result = await fetchProfilePicture();
        if (result.status !== 200) {
            this.setState({ isLoading: false, error: result.data });
        } else {
            this.setState({ isLoading: false, previewSrc: `${baseUrl}/${result.data.profilePicture}` });
        }
    }

    inputChangeHandler = event => {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
            this.setState({
                formModified: true,
                previewSrc: reader.result,
                selectedFile: event.target.files[0]
            });
        };
        reader.onerror = (error) => {
            this.setState({ error: error });
        }
    }

    formSubmitHandler = async event => {
        event.preventDefault();
        this.setState({ isLoading: true });
        const formData = new FormData();
        formData.append(
            "profilePicture",
            this.state.selectedFile,
            this.state.selectedFile.name
        );
        const result = await saveProfilePicture(formData);
        if (result.status !== 200) {
            this.setState({ isLoading: false, error: result.data });
        } else {
            this.setState({ isLoading: false, previewSrc: `${baseUrl}/${result.data.profilePicture}`, formModified: false });
        }
    }

    componentDidMount() {
        this.loadProfilePicture();
    }

    render() {

        let profilePictureModule = (
            <form className="form profile-picture-module" onSubmit={this.formSubmitHandler}>
                <h1 className="form__title">Profile Picture</h1>
                {this.state.error && <p className="form__error">{this.state.error.status}: {this.state.error.message}</p>}
                <div className="profile-picture__preview">
                    <img src={this.state.previewSrc} alt="UserImage" />
                </div>
                <input className="form__input" type="file" name="profilePicture" onChange={this.inputChangeHandler} />
                <button className="btn form__btn" type="submit" disabled={!this.state.formModified}>Save</button>
            </form>
        );

        if (this.state.isLoading) {
            profilePictureModule = <Spinner />
        }

        return profilePictureModule;
    }
}

export default ProfilePicture;